import {
  findExxatPaletteSwatch
} from "./chunk-NHLGTEVO.js";

// src/brand-color-match.ts
function brandColorsEquivalent(a, b) {
  const left = a?.trim();
  const right = b?.trim();
  if (!left || !right) return false;
  if (left.toLowerCase() === right.toLowerCase()) return true;
  const swatchA = findExxatPaletteSwatch(left);
  const swatchB = findExxatPaletteSwatch(right);
  if (swatchA && swatchB) {
    return swatchA.family === swatchB.family && swatchA.shade === swatchB.shade;
  }
  return false;
}

export {
  brandColorsEquivalent
};
